
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Title2',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
  },
})
